import { render } from "./basketball-court.svg?vue&type=template&id=20201865"
const script = {}
script.render = render

export default script